/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
const actions = {
    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////

    // Vertical NavMenu
    updateVerticalNavMenuWidth({ commit }, width) {
        commit("UPDATE_VERTICAL_NAV_MENU_WIDTH", width);
    },

    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
        commit("UPDATE_STARRED_PAGE", payload);
    },

    // The Navbar
    arrangeStarredPagesLimited({ commit }, list) {
        commit("ARRANGE_STARRED_PAGES_LIMITED", list);
    },
    arrangeStarredPagesMore({ commit }, list) {
        commit("ARRANGE_STARRED_PAGES_MORE", list);
    },

    // /////////////////////////////////////////////
    // UI
    // /////////////////////////////////////////////

    toggleContentOverlay({ commit }) {
        commit("TOGGLE_CONTENT_OVERLAY");
    },
    updateTheme({ commit }, val) {
        commit("UPDATE_THEME", val);
    },

    // /////////////////////////////////////////////
    // User/Account
    // /////////////////////////////////////////////

    updateUserInfo({ commit }, payload) {
        commit("UPDATE_USER_INFO", payload);
    },

    // Site Lists
    updateSiteLists({ commit }, data) {
        commit("UPDATE_SITE_INFO", data);
    },
    updateAreaLists({ commit }, data) {
        commit("UPDATE_AREA_INFO", data);
    },
    updateCompanyLists({ commit }, data) {
        commit("UPDATE_COMPANY_INFO", data);
    },
    updateCurrentSite({ commit }, data) {
      console.log("update current site ", data);
        commit("UPDATE_CURRENT_SITE", data);
    },
    updateCurrentArea({ commit }, data) {
        commit("UPDATE_CURRENT_AREA", data);
    },
    updateCurrentCamera({ commit }, data) {
        commit("UPDATE_CURRENT_CAMERA", data);
    },
    updateReportState({ commit }, data) {
        commit("UPDATE_REPORT_STATE", data);
    },
    updateCurrentCompany({ commit }, data) {
        commit("UPDATE_CURRENT_COMPANY", data);
    },
    updateCurrentUser({ commit }, data) {
        commit("UPDATE_CURRENT_USER", data);
    },
    saveSiteForm({ commit }, data) {
        commit("SAVE_SITE_FORM", data);
    },
    updateGneralData({ commit }, data) {
        commit("UPDATE_GENERAL_DATA", data);
    },
    embedAccess({ commit }, data) {
        commit("EMBED_ACCESS", data);
    },
    updateEventLists({ commit }, data) {
        commit("EVENT_LISTS", data);
    },
    updateSelectedSite({ commit }, data) {
        commit("UPDATE_SELECTED_SITE", data);
    },
    updateIsInOut({ commit }, data) {
    commit('SET_IS_IN_OUT', data);
  },
};

export default actions;